module.exports = __webpack_public_path__ + "static/media/ls_logo_horizontal_white.b7111999.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ls_logo_horizontal_white.svg
// module id = 1185
// module chunks = 0